import styled from "styled-components";

export const StyledRequestDocumentsListMobile = styled.div`
    flex: 1;
    max-height: calc(95vh - 40px);
    overflow: scroll;

    ul {
        height: 100%;
        padding: 0;
        margin: 0;
        border-right: 0;
    }

    .requestDocumentsItem {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 50px;
        max-height: 20px;
        padding: 30px 16px;
        cursor: pointer;
        border-bottom: 1px solid var(--color-grey-600);
        border-radius: var(--radius-5);

        &.active {
            background: var(--color-secondary-light);
        }

        .requestDocumentsTitle {
            width: 70%;
            overflow: hidden;
            font-size: var(--size-14);
            font-style: normal;
            line-height: 21px;
            color: var(--color-grey-900);
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .iconArrow {
            display: flex;
            width: 24px;
            height: 24px;
            background-color: var(--color-secondary);
            border-radius: 12px;

            svg {
                width: 24px;
                height: 24px;
                color: var(--color-secondary-fg);
            }
        }
    }
`;
